import { useQuery } from "@tanstack/react-query";
import SectionService from "services/SectionService";

export const useGetMenus = (siteId, queryOptions = {}) => {
  return useQuery({
    queryKey: ["getMenus", siteId],
    queryFn: () => SectionService.getMenu(siteId),
    enabled: !!siteId,
    ...queryOptions,
  });
};

export const useGetHeader = (siteId, queryOptions = {}) => {
  return useQuery({
    queryKey: ["getHeader", siteId],
    queryFn: () => SectionService.getHeader(siteId),
    enabled: !!siteId,
    ...queryOptions,
  });
};

export const useGetFooter = (siteId, queryOptions = {}) => {
  return useQuery({
    queryKey: ["getFooter", siteId],
    queryFn: () => SectionService.getFooter(siteId),
    enabled: !!siteId,
    ...queryOptions,
  });
};
